enum SentreeBadInstallSubEventTypes {
    unknown = 'Unknown',
    testUnit = 'TestUnit',
    commercialOrUnsupported = 'CommercialOrUnsupported',
    waterAffectingHarness = 'HW - Water affecting harness',
    inaccuratePressure = 'HW - Inaccurate pressure',
    eitherWaterAffectingHarnessOrInaccuratePressure = 'HW - Either water affecting harness or inaccurate pressure',
    tempSpikes = 'HW - Temp spikes',
    tempSquareWave = 'HW - Temp square wave',
    incorrectlyPottedPressureSensor = 'HW - Incorrectly potted pressure sensor',
    timestamp = 'HW - Timestamp',
    trueSuction = 'INST - True suction',
    wrongSideOfContactor = 'INST - Wrong side of contactor',
    incorrectCurrentClampInstall = 'INST - Incorrect current clamp install',
    tempsSwitched = 'INST - Temps switched',
    pressureSwitched = 'INST - Pressure switched',
    ambientTempPlacement = 'INST - Ambient temp placement',
    tempNotInstalled = 'INST - Temp not installed',
    pressureNotInstalled = 'INST - Pressure not installed',
    undercharged = 'HVAC - Undercharged',
    overcharged = 'HVAC - Overcharged',
    lowIndoorAirflow = 'HVAC - Low indoor airflow',
    lowOutdoorAirflow = 'HVAC - Low outdoor airflow',
    restriction = 'HVAC - Restriction',
    rustInhibitorStickyTxv = 'HVAC - Rust inhibitor sticky TXV',
    highPressureSwitchTripping = 'HVAC - High pressure switch tripping',
    deadband = 'HVAC - Deadband',
    fanMotorFailingToStart = 'HVAC - Fan motor failing to start',
    lockRotor = 'HVAC - Lock rotor',
    shortCycling = 'HVAC - Short cycling',
    communication = 'OTHER - Communication',
    offline = 'OTHER - Offline',
    suspectedWrongModelNumber = 'OTHER - Suspected wrong model number',
};

export default SentreeBadInstallSubEventTypes;